import { createClient } from '@/shared/api';
import UPLOAD_AI_REPORT_MUTATION from '@/entities/report/api/mutations/uploadAiReport';
import type {
  UploadAiReportMutation,
  UploadAiReportMutationVariables,
} from '@/shared/api/generated/graphql';

export type UploadAiReportResult = {
  isSuccess: boolean;
  message: string;
};

// TODO(ts): typed as the UploadAiReportInput GraphQL input once its server-side shape is documented
/**
 * Uploads a generated AI report to the server. Runs the uploadAiReport mutation and throws the server message when it reports failure.
 *
 * @param input - Mutation input carrying the report upload details.
 * @returns A promise resolving once the AI report upload has been accepted.
 */
const handleUploadAiReport = async (input: any) => {
  const client = await createClient();
  const uploadAiReportResult = await client.mutate<
    UploadAiReportMutation,
    UploadAiReportMutationVariables
  >({
    mutation: UPLOAD_AI_REPORT_MUTATION,
    variables: {
      input,
    },
  });
  const { data } = uploadAiReportResult;
  const { uploadAiReport } = data;
  if (!uploadAiReport.isSuccess) {
    throw new Error(uploadAiReport.message);
  }
};

export default handleUploadAiReport;
